//====================================================
//  Function: Fullpage
//====================================================
function fn_components_fullpage(){
	if ($( '.js-fullpage' ).length && $(window).width() > bp_medium){
		var sideNavigation = $( '.js-menu-navigation' );
		$('.js-fullpage').fullpage({
			afterLoad: function(anchorLink, index){
				sideNavigation.find( '.side-navigation-list-link.is-active' ).removeClass( class_active );
				sideNavigation.find( '.side-navigation-list-link[data-scroll="' + index + '"]' ).addClass( class_active );
				if (index == 3) {
					$( '.side-navigation-list' ).addClass( 'side-navigation-white' );
				} else {
					$( '.side-navigation-list' ).removeClass( 'side-navigation-white' );
				}

				if (index > 1) {
					$( '.navigation' ).addClass( 'navigation-scroll' );
				} else {
					$( '.navigation' ).removeClass( 'navigation-scroll' );
				}
			},
			afterRender: function(){
				if ($( '.js-video' ).length){
		        	$( '.js-video' )[0].play();      
				}
		    }
		});
	}
}
      
function fn_parts_fullpage_resize(){
	if ($(window).width() < bp_medium) {
		if ($( '.fp-section' ).length){
			$('.js-fullpage').fullpage.destroy('all');
		}
	} else{
		if (!$( '.fp-section' ).length){
			fn_components_fullpage();
		}
	}
}
